<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
                @change="getGroupItem"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >หมวดหมู่</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="group"
              >
                <option value="0">-- ทุกหมวดหมู่ --</option>
                <option
                  v-for="(g, i) in group_item"
                  :key="'gi' + i"
                  :value="g"
                >{{ g.name }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_cost_sale.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="sum_qty() === 0"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_cost_sale.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="sum_qty() === 0"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div class="table-responsive-sm mt-3">
          <table
            class="table"
            v-for="(c, i) in report_data"
            v-show="c.data !== null"
            :key="'c' + i"
          >
            <!-- <thead>
              <tr class="text-left">
                <td colspan="6">
                  วันที่: <span>{{ dateFormatDMY(startDate) }}</span>
                  <span v-if="dateFormatDMY(startDate) !== dateFormatDMY(endDate)">ถึง วันที่: {{ dateFormatDMY(endDate) }}</span>
                </td>
              </tr>
            </thead> -->
            <tbody
              v-for="(d, s) in c.data"
              :key="'d' + s"
            >
              <tr
                class="text-left"
                v-if="s === 0"
              >
                <th
                  colspan="6"
                  style="font-size: 20px;"
                >
                  สาขา: {{ c.branch_name }}
                </th>
              </tr>
              <tr
                class="text-left"
                v-if="d.profit.sub.length > 0"
              >
                <th colspan="6">
                  หมวดหมู่: {{ d.group_name }}
                </th>
              </tr>
              <tr
                class="text-left"
                v-if="d.profit.sub.length > 0"
              >
                <th colspan="6">
                  {{ d.profit.date }}
                </th>
              </tr>
              <tr
                class="thead-dark text-center"
                v-if="d.profit.sub.length > 0"
              >
                <th width="20%">รหัส: ชื่อ</th>
                <th class="text-right" width="15%">จำนวน</th>
                <th class="text-right" width="10%">มูลค่าขาย</th>
                <th class="text-right" width="10%">มูลค่าทุนชื้อ</th>
                <th class="text-right" width="10%">ต้นทุน/หน่วย</th>
                <th class="text-right" width="10%">กำไรขั้นต้น</th>
                <th class="text-right" width="10%">ภาษี 7 %</th>
                <th class="text-right" width="10%">กำไร %</th>
              </tr>
              <tr
                v-for="(sub, i) in d.profit.sub"
                v-show="d.profit.sub.length > 0"
                :key="'sub' + i"
              >
                <td class="text-left">{{ sub.item_code || '-'}}: {{ sub.item_name || '-' }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.qty) }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_sale) }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_buy) }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_buy / sub.qty) }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.gross_profit) }}</td>
                <td class="text-right">{{ sub.is_vat == 1 ? numberFormatDecimal(sub.avg_cost_sale * 7 / 107) : numberFormatDecimal(sub.tax_amount) }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.gpm) }} %</td>
              </tr>
              <tr
                v-if="d.profit.sub.length > 0"
                style="background: #f7f7f7;"
              >
                <th class="text-left">รวม</th>
                <th class="text-right">{{ numberFormatDecimal(d.profit.sum_qty) }}</th>
                <th class="text-right">{{ numberFormatDecimal(d.profit.sum_avg_cost_sale) }}</th>
                <th class="text-right">{{ numberFormatDecimal(d.profit.sum_avg_cost_buy) }}</th>
                <td class="text-right">{{ numberFormatDecimal(sumall_gross_profit_profile(d.profit.sub)) }}</td>
                <th class="text-right">{{ numberFormatDecimal(d.profit.sum_gross_profit) }}</th>
                <td class="text-right">{{ numberFormatDecimal(sumall_suminrow_taxamount(d.profit.sub)) }}</td>
                <th class="text-right">{{ numberFormatDecimal(d.profit.sum_gpm) }} %</th>
              </tr>
              <!-- <tr
                v-if="s === checkLastBranch(c.data) && total_qty(c.data) > 0"
                style="background: #f7f7f7; font-size: 18px;"
              >
                <th class="text-left"></th>
                <th class="text-right">{{ numberFormatDecimal(total_qty(c.data)) }}</th>
                <th class="text-right">{{ numberFormatDecimal(total_avg_cost_sale(c.data)) }}</th>
                <th class="text-right">{{ numberFormatDecimal(total_avg_cost_buy(c.data)) }}</th>
                <th class="text-right"></th>
                <th class="text-right">{{ numberFormatDecimal(total_gross_profit(c.data)) }}</th>
                <th class="text-right">{{ numberFormatDecimal((total_gross_profit(c.data) / total_avg_cost_sale(c.data)) * 100) }} %</th>
              </tr> -->
            </tbody>
          </table>
          <table class="table">
            <tr
              v-if="sum_qty() !== 0"
              style="background: #f7f7f7; font-size: 20px;"
            >
              <th
                class="text-left"
                width="20%"
              >รวมทุกสาขา</th>
              <th
                class="text-right"
                width="15%"
              >จำนวน</th>
              <th
                class="text-right"
                width="10%"
              >มูลค่าขาย</th>
              <th
                class="text-right"
                width="10%"
              >มูลค่าทุนชื้อ</th>
              <th
                class="text-right"
                width="10%"
              >กำไรขั้นต้น</th>
              <th
                class="text-right"
                width="10%"
              >
                <!-- {{ numberFormatDecimal(sumall_gpm()) }} % -->
                VAT 7 %
              </th>
              <th
                class="text-right"
                width="10%"
              >
                <!-- {{ numberFormatDecimal(sumall_gpm()) }} % -->
                กำไร %
              </th>
            </tr>
            <tr
              v-if="sum_qty() !== 0"
              style="background: #f7f7f7; font-size: 20px;"
            >
              <th
                class="text-left"

              ></th>
              <th
                class="text-right"
              >{{ numberFormatDecimal(sumall_qty()) }}</th>
              <th
                class="text-right"
              >{{ numberFormatDecimal(sumall_avg_cost_sale()) }}</th>
              <th
                class="text-right"
              >{{ numberFormatDecimal(sumall_avg_cost_buy()) }}</th>
              <th
                class="text-right"
              >{{ numberFormatDecimal(sumall_gross_profit()) }}</th>
              <th
                class="text-right"
              >{{ numberFormatDecimal(sumall_tax_amount()) }}</th>
              <th
                class="text-right"
              >
                <!-- {{ numberFormatDecimal(sumall_gpm()) }} % -->
                {{ numberFormatDecimal((sumall_gross_profit() / sumall_avg_cost_sale()) * 100) }}
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
import moment from 'moment'
import api from '../services/service_report'
import apiD from '../services/service'
// import apiItem from '../services/service_item'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      strucB: [],
      group_item: [],
      all_data: [],
      group: 0,
      price_cal_vat: 0
    }
  },
  methods: {
    async getReport () {
      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }

      this.all_data = [];
      this.$store.state.isLoading = true;

     if (branch === 0) {
        this.$store.state.isLoading = true;

        for (let values of this.$store.state.branch_list) {
          const obj = {
            start_date: this.dateFormatDMY2(this.startDate),
            end_date: this.dateFormatDMY2(this.endDate),
            company_id: 1,
            branch_id: values.id,
            item_code: '',
            item_group: (this.group === 0) ? '' : this.group.code,
            group_start: (this.group === 0) ? '' : this.group.code,
            group_end: (this.group === 0) ? '' : this.group.code
          };

          try {
            // เพิ่ม timestamp กัน cache
            const urlWithNoCache = sessionStorage.Url

            const data = await this.standardReportPromise(urlWithNoCache, this.header, obj);

            this.all_data.push(...data.branch_sub);

            // รอ 5 วินาที ก่อนดึงข้อมูลสาขาถัดไป
            await new Promise(resolve => setTimeout(resolve, 3000));

          } catch (error) {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: error.message || 'เกิดข้อผิดพลาด'
            });
          }
        }

        this.$store.state.isLoading = false;

        if (this.all_data.length === 0) {
          this.$notification['warning']({
            message: 'ไม่มีข้อมูล',
            description: 'ไม่พบข้อมูลในช่วงวันที่ที่เลือก'
          });
        } else {
          const sortData = this.all_data.sort((a, b) => a.branch_name.localeCompare(b.branch_name));
          this.report_data = sortData;
          this.form_data = JSON.stringify(sortData);

          sortData.forEach(element => {
            if (element.data) {
              const groupData = element.data.sort((a, b) => a.group_code - b.group_code);
              groupData.forEach(element1 => {
                if (element1.profit.sub === null) {
                  element1.profit.sub = [];
                }
                element1.profit.sub.sort((a, b) => a.item_code - b.item_code);
              });
            }
          });
        }
      } else {
        const obj = {
          start_date: this.dateFormatDMY2(this.startDate),
          end_date: this.dateFormatDMY2(this.endDate),
          company_id: 1,
          branch_id: branch,
          item_code: '',
          item_group: (this.group === 0) ? '' : this.group.code,
          group_start: (this.group === 0) ? '' : this.group.code,
          group_end: (this.group === 0) ? '' : this.group.code
        };

        try {
          const data = await this.standardReportPromise(sessionStorage.Url, this.header, obj);
          this.$store.state.isLoading = false;

          const sortData = data.branch_sub.sort((a, b) => a.branch_name.localeCompare(b.branch_name));
          this.report_data = sortData;
          this.form_data = JSON.stringify(sortData);

          sortData.forEach(element => {
            if (element.data) {
              const groupData = element.data.sort((a, b) => a.group_code - b.group_code);
              groupData.forEach(element1 => {
                if (element1.profit.sub === null) {
                  element1.profit.sub = [];
                }
                element1.profit.sub.sort((a, b) => a.item_code - b.item_code);
              });
            }
          });

        } catch (error) {
          this.$store.state.isLoading = false;
          this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: error.message || 'เกิดข้อผิดพลาด'
          });
        }
      }
    },
    standardReportPromise (url, header, obj) {
      return new Promise((resolve, reject) => {
        api.StandardReport(
          url,
          header,
          obj,
          result => {
            if (result.response === 'success') {
              resolve(result.data);
            } else {
              reject(new Error(result.message));
            }
          },
          error => {
            reject(error);
          }
        );
      });
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    sum_qty () {
      var sumQty = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            val['profit']['sub'].forEach(v => {
              sumQty += v['cn_qty']
            })
          })
        }
      })
      return sumQty
    },
    sumall_qty () {
      var sum = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
            // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_qty']
            // }
            }
          })
        }
      })
      return sum
    },
    sumall_avg_cost_sale () {
      var sum = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
            // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_avg_cost_sale']
            // }
            }
          })
        }
      })
      return sum
    },
    sumall_avg_cost_buy () {
      var sum = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
            // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_avg_cost_buy']
            // }
            }
          })
        }
      })
      return sum
    },
    sumall_tax_amount () {
      var sum = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
              val['profit']['sub'].forEach(_val => {
              // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
                sum += _val['is_vat'] === 1 || _val['tax_amount'] > 0 ? _val['avg_cost_sale'] : 0;
              // }
              })
            }
          })
        }
      })
      return parseFloat(parseFloat(sum * 7 / 107).toFixed(2))
    },
    sumall_gross_profit_profile (sub) {
      var sum = 0
      sub.forEach(o => {
        sum += o['avg_cost_buy'] / o['qty']
      })
      return sum
    },
    sumall_gross_profit () {
      var sum = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
            // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_gross_profit']
            // }
            }
          })
        }
      })
      return sum
    },
    sumall_gpm () {
      var sum = 0
      var i = 0
      this.report_data.forEach(o => {
        if (o['data'] !== null) {
          o['data'].forEach(val => {
            if(val['group_code'] !== '9100') {
            // if(val['profit']['sub'].filter((e) => e.item_code.length < 5).length > 0) {
              sum += val['profit']['sum_gpm']
            // }
            }
          })
          i++
        }
      })
      return sum / i
    },
    sumall_suminrow_taxamount (sub) {
      var sum = 0
      sub.forEach(o => {
      console.log(o)
        if (o['is_vat'] === 1) {
          // console.log(parseFloat(parseFloat(o['avg_cost_sale'] * 7 / 107).toFixed(2)))
          sum += parseFloat(parseFloat(o['avg_cost_sale'] * 7 / 107).toFixed(2))
          
        } else {
          sum += 0
        }
      })
      return sum
    },
    checkSub (obj) {
      var len = 0
      if (obj !== null) {
        len += obj.profit.sub.length
      }
      return len
    },
    checkLastBranch (obj) {
      var len = 0
      obj.forEach(v => {
        if (v['profit']['sub'].length > 0) {
          len++
        }
      })
      return len
    },
    total_qty (obj) {
      var sum = 0
      obj.forEach(v => {
        sum += v['profit']['sum_qty']
      })
      return sum
    },
    total_gross_profit (obj) {
      var sum = 0
      obj.forEach(v => {
        sum += v['profit']['sum_gross_profit']
      })
      return sum
    },
    total_avg_cost_sale (obj) {
      var sum = 0
      obj.forEach(v => {
        sum += v['profit']['sum_avg_cost_sale']
      })
      return sum
    },
    total_avg_cost_buy (obj) {
      var sum = 0
      obj.forEach(v => {
        sum += v['profit']['sum_avg_cost_buy']
      })
      return sum
    },
    getGroupItem () {
      var branch = 0
      if (parseInt(this.branch) === 0) {
        branch = this.$store.state.branch_list[0]
      } else {
        branch = this.branch
      }
      // apiItem.itemGroup(
      apiD.callMisApi(
        branch.dyn_address + '/' + 'product/v1/item/group',
        {
          headers: {
            'client-token': branch.access_token,
            'access-token': sessionStorage.token
          }
        },
        {},
        result => {
          console.log(result.response)
          if (result.response === 'success') {
            this.group_item = result.data
            // this.group_data = [{
            //   name: 'ทุกกลุ่มสินค้า', code: ''
            // }]
            // result.data.forEach(val => {
            //   this.group_data.push({
            //     name: val['code'] + ': ' + val['name'],
            //     code: val['code']
            //   })
            // })
          } else {
            this.alert('warning', 'ดึงข้อมูลสินค้าไม่ได้', result.message)
          }
        },
        error => {
          this.alert('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    }
    // getGroupItem () {
    //   var obj = {
    //     'id': 0,
    //     'company_id': 1,
    //     'branch_id': 1,
    //     'begin_date': this.dateFormatDMY2(this.startDate),
    //     'end_date': this.dateFormatDMY2(this.endDate)
    //   }
    //   this.$store.state.isLoading = true
    //   apiD.DashBoard(
    //     sessionStorage.Url,
    //     this.header,
    //     obj,
    //     result => {
    //       if (result.response === 'success') {
    //         this.$store.state.isLoading = false
    //         this.Sale_amount = 0
    //         this.Profit_amount = 0
    //         this.group_item = []
    //         result.data.forEach(v => {
    //           if (v !== null && v.length > 0) {
    //             v.forEach(val => {
    //               var check = this.group_item.findIndex(i => parseInt(i.group_code) === parseInt(val['group_code']))
    //               if (check < 0) {
    //                 this.group_item.push(val)
    //               }
    //             })
    //           }
    //         })
    //       } else {
    //         this.$store.state.isLoading = false
    //         this.alert_msg('warning', 'ดึงข้อมูลรายงานไม่ได้', result.message)
    //       }
    //     },
    //     error => {
    //       this.$store.state.isLoading = false
    //       this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
    //     }
    //   )
    // }
  },
  mounted () {
    this.checkUser()
    this.getBranch()
    setTimeout(() => {
      this.getGroupItem()
    }, 1000)
    // this.getReport()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report_cost_standard.vue